import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import DateWithClear from "Components/UI/Form/DateWithClear";
import dayjs from "dayjs";

export default function EndCustomerPaymentBundleGeneral({
  formData,
  FORM_MODE,
  handleInputChange,
}) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled
            name="Id"
            label="ID"
            value={formData?.Id ?? ""}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={FORM_MODE === "LOCKED"}
            name="PaymentAmount"
            label="Summa"
            value={formData?.PaymentAmount ?? ""}
            onChange={(e) => handleInputChange("PaymentAmount", e.target.value)}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="Betalningsdatum"
            value={dayjs(formData?.PaymentDate ?? "")}
            disabled={FORM_MODE === "LOCKED"}
            onChange={(newVal) =>
              handleInputChange(
                "PaymentDate",
                dayjs(newVal).format("YYYY-MM-DD")
              )
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={FORM_MODE === "LOCKED"}
            name="PaymentCount"
            label="Antal"
            value={formData?.PaymentCount ?? ""}
            onChange={(e) => handleInputChange("PaymentCount", e.target.value)}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={FORM_MODE === "LOCKED"}
            name="PaymentAccount"
            label="Betalningskonto"
            value={formData?.PaymentAccount ?? ""}
            onChange={(e) =>
              handleInputChange("PaymentAccount", e.target.value)
            }
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={FORM_MODE === "LOCKED"}
            name="FileId"
            label="Fil ID"
            value={formData?.FileId ?? ""}
            onChange={(e) => handleInputChange("FileId", e.target.value)}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={FORM_MODE === "LOCKED"}
            name="FileName"
            label="Filnamn"
            value={formData?.FileName ?? ""}
            onChange={(e) => handleInputChange("FileName", e.target.value)}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
      </Grid>
    </>
  );
}
